import $ from 'jquery';

/**
 * Defines the className of the dot button
 * @type {string}
 */
export const DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
export default function customPaging(slickInstance, i, showAsNumber = false) {
  // Check if the pagination should be shown as "1 of 5" or as dots
  const $slides = slickInstance.$slides;
  const total_images = $slides.length;
  const totalDots = slickInstance.getDotCount();
  const currentPage = i + 1;
  const id = $slides[i].id || '';
  if (showAsNumber) {
    // Show "1 of X" in a <p> tag if showAsNumber is true
    return $(`
      <p class="carousel__dot-text">
        <span class="u-screen-reader">Page ${currentPage} of ${totalDots + 1}</span>
        ${currentPage} of ${totalDots + 1}
      </p>
    `);
  } else {
    // Default to button if showAsNumber is false
    return $(`
      <button href="#${id}" class="${DOT_CLASS}" data-role="none">
        <span class="u-screen-reader">Showing <span class="slide-image-count"></span> images, page ${currentPage} of <span class="slides-to-show">${total_images}</span><span class="image-carousel__dots-active-text">, currently selected</span></span>
      </button>
    `);
  }
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/custom-paging.js